















































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

interface ItemOption {
  title: string;
  content: string | number;
  emphasize?: boolean;
  subContent?: string;
  tooltip?: string;
  routeTo?: {
    name: string;
    params: {
      [key: string]: any;
    };
  }
}

@Component({})
export default class CaseFoldingCard extends Vue {
  @Prop({ type: [String, Number] }) readonly title!: string | number
  @Prop({ type: [String, Number] }) readonly subTitle!: string | number
  @Prop({ type: Array, default: [] }) readonly items!: ItemOption[]
  @Prop({ type: Boolean, default: false }) readonly contentNoPadding!: boolean
  @Prop({ type: Boolean, default: true }) readonly showFoldingIcon!: boolean
  @Prop({ type: Number, default: 250 }) readonly titleWidth!: number
  @Prop({ type: Boolean, default: false }) readonly editState!: boolean
  @Prop({ type: Boolean, default: false }) readonly noViewAll!: boolean
  @Prop({ type: Boolean, default: false }) readonly unFolding!: boolean
  @Prop({ type: Boolean, default: false }) readonly sub!: boolean
  @Prop({ type: Boolean, default: false }) readonly warning!: boolean

  folding = true

  mounted () {
    this.folding = !this.unFolding
  }

  handleFolding () {
    this.folding = !this.folding
  }

  routeTo (item: ItemOption) {
    if (item.routeTo) {
      this.$router.push({
        name: item.routeTo.name,
        params: item.routeTo.params
      })
    }
  }

  @Watch('unFolding')
  onUnfoldingChanged (val: boolean) {
    this.folding = !val
  }
}
